import { useMemo } from "react"
import { ELEMENT_COLORS, ELEMENT_NAMES } from "@/constants/guardians"
import { BattleCardView, GameCard } from "@/types/battle"
import { CardShapeLayout } from "./cardShapeLayout"
import { getInstalledShardSlots } from "./cardShardLayout"

export type FooterMetaMode = "full" | "hidden" | "shards"

interface CardFooterMetaProps {
  card: BattleCardView | GameCard
  layout: CardShapeLayout
  mode?: FooterMetaMode
}

export default function CardFooterMeta({
  card,
  layout,
  mode = "full",
}: CardFooterMetaProps) {
  const { scale } = layout
  const compact = scale < 0.75
  const elementColor = ELEMENT_COLORS[card.element] ?? "#fff"
  const installedShards = useMemo(
    () => getInstalledShardSlots("shardSlots" in card ? card.shardSlots : null),
    [card]
  )

  const elementFont = Math.max(14, 20 * scale)
  const metaFont = Math.max(8, 10 * scale)
  const levelNumFont = Math.max(14, 20 * scale)

  const metaWidth =
    installedShards.length > 0
      ? compact
        ? layout.innerW * 0.55
        : layout.innerW * 0.5
      : compact
        ? layout.innerW * 0.68
        : layout.innerW * 0.52

  if (mode === "shards" || mode === "hidden") return null

  return (
    <div
      className="pointer-events-none absolute left-0 z-[1] flex flex-col justify-start"
      style={{
        top: layout.bottomLayerTop,
        width: metaWidth,
        height: layout.bottomBlockH,
        paddingTop: Math.max(32, 40 * scale),
        paddingLeft: Math.max(6, 8 * scale),
        paddingRight: 4 * scale,
      }}
    >
      <div
        className="truncate font-black"
        style={{
          color: elementColor,
          fontSize: elementFont,
          lineHeight: `${elementFont * 1.05}px`,
          letterSpacing: compact ? 0.3 : 0.8,
          textShadow: "0 1px 3px rgba(0,0,0,0.45)",
        }}
      >
        {ELEMENT_NAMES[card.element] ?? card.element}
      </div>
      <div
        className="flex flex-row items-baseline"
        style={{ marginTop: -1 * layout.scale }}
      >
        <span
          className="font-bold text-white/85"
          style={{
            fontSize: metaFont,
            lineHeight: `${metaFont * 1.1}px`,
            letterSpacing: 0.4,
          }}
        >
          УРОВЕНЬ{" "}
        </span>
        <span
          className="font-black text-white"
          style={{
            fontSize: levelNumFont,
            lineHeight: `${levelNumFont * 1.05}px`,
          }}
        >
          {card.level}
        </span>
      </div>
    </div>
  )
}
